export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/doorman-c3d97b3f3dad299c48d5cb17dd4e9bcd.svg";